import YYSecurityUpload from './upload'
import YYSecurityUploadSortAll from './upload-sort-all'
import YYSecurityUploadList from './upload-list'

YYSecurityUpload.YYSecurityUploadList = YYSecurityUploadList
YYSecurityUpload.YYSecurityUploadSortAll = YYSecurityUploadSortAll
export { YYSecurityUpload, YYSecurityUploadList, YYSecurityUploadSortAll }
export default YYSecurityUpload